import {Component, OnDestroy} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {AuthenticatedUser, Club} from '../../models';
import {NavigationService, StorageService} from '../../services';

/**
 * Displays the sidebar of the application.
 */
@UntilDestroy()
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnDestroy {
  public authenticatedUser: AuthenticatedUser;
  public selectedClub: Club;
  public currentPage: string;

  constructor(public storage: StorageService, public navigationService: NavigationService) {
    if (this.storage.isLoggedIn()) {
      this.storage.authenticatedUser
        .pipe(untilDestroyed(this))
        .subscribe((user: AuthenticatedUser) => this.authenticatedUser = user);
      this.navigationService.castCurrentPage
        .pipe(untilDestroyed(this))
        .subscribe((data: string) => this.currentPage = data);
    }
  }

  public ngOnDestroy(): void {
  }
}
